<template>
  <div class="jinanLogo flex">
    <div class="leftIcon">
      <img :src="nameList.homeLogoUrl" alt="" />
    </div>
    <div class=" rightFont ml10">
      <p class="font chinese">{{ nameList.homeBigTitle }}</p>
      <p class="font english">{{ nameList.homeSmallTitle }}</p>
    </div>
  </div>
</template>

<script>
export default {
  props: ["nameList"],

  methods: {},
};
</script>

<style scoped lang="scss">
.jinanLogo {
  padding-left: 20px;
  width: 300px;
  margin-left: 60px;
}
.leftIcon {
  height: 50px;
  display: flex;
  align-content: center;

  margin-top: 3px;
  img {
    height: 100%;
    width: 100%;
  }
}
.rightFont {
  color: #fff;
  font-size: 20px;
  .chinese {
    margin-top: 3px;
    letter-spacing: 8px;
    padding-left: 10px;
  }
  .english {
    font-size: 12px;
    line-height: 18px;
    letter-spacing: 2px;
  }
}
.pagination-container {
  background: #fff;
  padding: 32px 16px;
}
.pagination-container.hidden {
  display: none;
}
</style>
